import { CascadiaJsonFormContext } from "@certn/forms";
import { ArrayControlProps } from "@jsonforms/core";
import { withJsonFormsArrayControlProps } from "@jsonforms/react";
import { useContext } from "react";

import { EducationHistoryControl } from "./EducationHistoryControl";
import { EducationHistorySummaryControl } from "./EducationHistorySummaryControl";

/* eslint-disable react-hooks/rules-of-hooks */
function _EducationHistoryControl(props: ArrayControlProps) {
  const { isSummary } = useContext(CascadiaJsonFormContext);

  if (isSummary) {
    return <EducationHistorySummaryControl {...props} />;
  }

  return <EducationHistoryControl {...props} />;
}
/* eslint-enable react-hooks/rules-of-hooks */

export const EducationHistoryControlRenderer = withJsonFormsArrayControlProps(
  _EducationHistoryControl
);
